<template>
  <div>
    <v-btn color="admin" dark outlined @click="onConfig">
      <v-icon left>mdi-clock</v-icon>Cấu hình Hạn đăng ký Chung
    </v-btn>
    <ConfigDialog ref="config-dialog" />
  </div>
</template>
<script>
import ConfigDialog from './ConfigDialog.vue'
export default {
  components: {ConfigDialog},
  methods: {
    onConfig() {
      this.$refs['config-dialog'].openDialog()
    },
  },
}
</script>